<div class="divider-horizontal"></div>
<h3>Apartments on this property</h3>
<div class="swiper-wrapper">
  <swiper-container slides-per-view="4" space-between="10">
    @for (property of units; track property) {
      <swiper-slide>
        <app-property-card [parentName]="parentName" [parentId]="parentId" [property]="property" [innerCard]="true"></app-property-card>
      </swiper-slide>
    }
  </swiper-container>
</div>
